module.exports = __webpack_public_path__ + "static/media/container.737a48f4.svg";